/* E-VESTE 16/10/2026 (push-30, voce D3 «Il capo veste la pagina»). Lo script della pelle leggera delle schede normali, caricato solo da
   sections/bh-veste.liquid quando il capo ha la palette. Poco JS, nessuna libreria. Fa sette cose:
   1. rifà le misure del titolo enorme, della foto al telefono e della banda (le funzioni stanno in window.bhVeste, nella sezione, e girano
      già prima della prima resa) quando il font arriva, la larghezza cambia o cambia il colore;
   2. al telefono la foto prende così l'altezza che resta: titolo, foto, prezzo, taglie e bottone stanno nella prima schermata;
   3. col colore riveste la pagina (i colori della palette di quel colore, dal JSON della sezione);
   4. dice al CSS se la scelta è completa (bottone vuoto e bordato finché manca la taglia, pieno nel segno quando c'è);
   5. mette sulla foto il cuore dei preferiti e «Manda questa pagina», e la stessa scritta sotto il bottone;
   6. mette le taglie nella barra fissa, che seguono quelle della cassa (un tocco nella barra sceglie la taglia della cassa);
   7. senza taglia, il tocco su ACQUISTA nella barra porta alle taglie con l'avviso, come il bottone della cassa.
   Il carrello, le varianti, i prezzi, la barra e le foto restano quelli del tema (global.js, product-form.js, main-product). */
(function () {
  'use strict';
  var d = document, h = d.documentElement;
  var datiEl = d.getElementById('bh-v-dati');
  if (!datiEl || !h.classList.contains('bh-veste')) return;
  var dati;
  try { dati = JSON.parse(datiEl.textContent); } catch (e) { return; }

  var telefono = window.matchMedia('(max-width: 767px)');
  var info = d.querySelector('#MainContent [id^="ProductInfo-"]');
  var radios = info ? info.querySelector('variant-radios') : null;
  var galleria = d.querySelector('#MainContent media-gallery[id^="MediaGallery-"]');
  var barra = d.querySelector('sticky-cart-modal[id^="sticky-cart-"]');

  // ---------- varianti e scelta ----------
  function varianti() {
    var j = radios ? radios.querySelector('script[type="application/json"]') : null;
    try { return j ? JSON.parse(j.textContent) : []; } catch (e) { return []; }
  }
  function gruppi() { return radios ? Array.prototype.slice.call(radios.querySelectorAll('fieldset')) : []; }
  function scelta() {
    var gs = gruppi(), valori = [];
    for (var i = 0; i < gs.length; i++) {
      var c = gs[i].querySelector('input[type=radio]:checked');
      if (!c) return null;
      valori.push(c.value);
    }
    return varianti().filter(function (v) {
      return v.options && v.options.length === valori.length && v.options.every(function (o, k) { return o === valori[k]; });
    })[0] || null;
  }
  function pronto() {
    var si;
    if (!radios) {
      var b = info ? info.querySelector('.product__buttons [name="add"]') : null;
      si = !!(b && !b.disabled);
    } else {
      var v = scelta();
      si = !!(v && v.available);
    }
    h.setAttribute('data-bh-v-pronto', si ? 'si' : 'no');
  }

  // il logo di Scalapay prende il colore dall'attributo del suo elemento (nero fisso nello snippet): nell'inchiostro della pagina
  // Questo script gira prima di quello di Scalapay (defer, più in basso nella pagina), quindi di solito basta cambiare l'attributo; se
  // l'elemento è già disegnato (dopo un cambio di colore) lo si rimette uguale coi due colori nuovi, così si ridisegna.
  function rate() {
    var ink = getComputedStyle(h).getPropertyValue('--bh-v-i').trim();
    if (!ink || !info) return;
    var definito = window.customElements && window.customElements.get('scalapay-widget');
    info.querySelectorAll('scalapay-widget').forEach(function (w) {
      if (w.getAttribute('logocolor') === ink && w.getAttribute('pricecolor') === ink) return;
      if (!definito) { w.setAttribute('logocolor', ink); w.setAttribute('pricecolor', ink); return; }
      var n = w.cloneNode(false);
      n.setAttribute('logocolor', ink);
      n.setAttribute('pricecolor', ink);
      w.replaceWith(n);
    });
  }

  // il contatore della galleria parte da 1: lo script del tema (slider-buttons) ci scriveva il numero della prima foto fra tutte, anche
  // quelle degli altri colori («7 / 12»). Con la classe change_current_index quello script si ferma; global.js conta poi le foto viste.
  function contatore() {
    var sl = galleria ? galleria.querySelector('.slider-mobile-product') : null;
    var n = galleria ? galleria.querySelector('#current-slider') : null;
    if (!sl || !n) return;
    sl.classList.add('change_current_index');
    var lista = sl.querySelector('.product__media-list');
    if (!lista || Math.abs(lista.scrollLeft) < 4) n.textContent = '1';
  }

  // dal computer la galleria è un mosaico (una grande, due piccole): l'ultima foto rimasta sola prende tutta la riga
  function mosaico() {
    if (!galleria) return;
    var vs = Array.prototype.filter.call(galleria.querySelectorAll('.product__media-list > .product__media-item'), function (li) {
      li.classList.remove('bh-v-sola');
      return !li.classList.contains('hidden');
    });
    var n = vs.length, resto = (n - 1) % 5;
    if (n > 1 && resto % 2 === 1) vs[n - 1].classList.add('bh-v-sola');
  }

  // ---------- 3. il colore riveste la pagina ----------
  function chiaveDaColore(valore) {
    var gs = gruppi(), idx = -1;
    for (var i = 0; i < gs.length; i++) { if (gs[i].hasAttribute('data-bh-colore')) { idx = i; break; } }
    if (idx < 0) return null;
    var vs = varianti().filter(function (v) { return v.options && v.options[idx] === valore; });
    for (var j = 0; j < vs.length; j++) {
      var id = String(vs[j].id);
      var k = dati.per_variante && dati.per_variante[id];
      if (k && dati.colori[k]) return k;
      for (var c in dati.colori) {
        if (Object.prototype.hasOwnProperty.call(dati.colori, c) && (dati.colori[c].varianti || []).indexOf(id) > -1) return c;
      }
    }
    return dati.predefinito && dati.colori[dati.predefinito] ? dati.predefinito : null;
  }
  function veste(chiave) {
    var c = dati.colori[chiave];
    if (!c || chiave === dati.chiave) return;
    dati.chiave = chiave;
    var forma = 'toppa', stampa = 'si';
    String(c.decl || '').split(';').forEach(function (coppia) {
      var i = coppia.indexOf(':');
      if (i < 1) return;
      var nome = coppia.slice(0, i).trim(), valore = coppia.slice(i + 1).trim();
      if (nome === '--bh-v-forma') forma = valore;
      if (nome === '--bh-v-stampa') stampa = valore;
      h.style.setProperty(nome, valore);
    });
    h.classList.remove('bh-veste--trama', 'bh-veste--banda', 'bh-veste--toppa');
    h.classList.add('bh-veste--' + forma);
    h.classList.toggle('bh-veste--senza-stampa', stampa === 'no');
    var meta = d.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', getComputedStyle(h).getPropertyValue('--bh-v-p').trim());
    rate();
    window.requestAnimationFrame(function () { misura(); });
  }

  // ---------- 1 e 2. titolo, foto al telefono e banda: le misure stanno in window.bhVeste, nella sezione ----------
  function misura() {
    if (window.bhVeste) window.bhVeste.tutto();
  }

  // ---------- 5. il cuore e «Manda questa pagina» sulla foto, e la scritta sotto il bottone ----------
  var stato = null;
  function manda() {
    var cosa = { title: dati.titolo || d.title, text: dati.testo || '', url: location.href };
    if (navigator.share) { navigator.share(cosa).catch(function () {}); return; }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(location.href).then(function () {
        if (!stato) return;
        stato.textContent = dati.copiato || '';
        setTimeout(function () { stato.textContent = ''; }, 4000);
      }).catch(function () {});
    }
  }
  var ICONA_MANDA = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M12 3v12M7 8l5-5 5 5"/></svg>';
  function sullaFoto() {
    if (!galleria || galleria.querySelector('.bh-v-sulla-foto')) return;
    var box = d.createElement('div');
    box.className = 'bh-v-sulla-foto';
    var cuore = info ? info.querySelector('.wishlist-heart-pp') : null;
    if (cuore) box.appendChild(cuore);
    if (dati.manda) {
      var b = d.createElement('button');
      b.type = 'button';
      b.className = 'bh-v-tondo';
      b.setAttribute('aria-label', dati.manda);
      b.innerHTML = ICONA_MANDA;
      b.addEventListener('click', manda);
      box.appendChild(b);
    }
    if (box.children.length) galleria.appendChild(box);
    var riga = info ? info.querySelector('.size_and_wishlist') : null;
    if (riga && dati.manda && !riga.querySelector('.bh-v-manda')) {
      var l = d.createElement('button');
      l.type = 'button';
      l.className = 'bh-v-manda';
      l.textContent = dati.manda;
      l.addEventListener('click', manda);
      riga.appendChild(l);
      stato = d.createElement('p');
      stato.className = 'bh-v-avvisa';
      stato.setAttribute('role', 'status');
      stato.setAttribute('aria-live', 'polite');
      riga.appendChild(stato);
    }
  }

  // ---------- 6. le taglie nella barra fissa ----------
  function gruppoTaglie() {
    if (!radios) return null;
    return radios.querySelector('fieldset.variant_taglia') || radios.querySelector('fieldset[data-bh-taglie]');
  }
  function pilloleBarra() {
    if (!barra) return;
    var riga = barra.querySelector('.sticky-cart');
    var g = gruppoTaglie();
    if (!riga || !g) return;
    var box = riga.querySelector('.bh-v-barra-taglie');
    if (!box) {
      box = d.createElement('div');
      box.className = 'bh-v-barra-taglie';
      box.setAttribute('role', 'group');
      var et = g.querySelector('.bh-taglie__etichetta');
      var nome = et ? (et.childNodes[0] && et.childNodes[0].nodeValue || et.textContent) : '';
      if (nome) box.setAttribute('aria-label', nome.trim());
      riga.insertBefore(box, riga.firstChild);
      box.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('button[data-per]') : null;
        if (!b || b.getAttribute('aria-disabled') === 'true') return;
        var inp = d.getElementById(b.getAttribute('data-per'));
        if (inp && !inp.checked) inp.click();
      });
    }
    var ins = g.querySelectorAll('input[type=radio]');
    var html = '';
    for (var i = 0; i < ins.length; i++) {
      var esaurita = ins[i].classList.contains('disabled');
      html += '<button type="button" data-per="' + ins[i].id + '" aria-pressed="' + (ins[i].checked ? 'true' : 'false') + '"' +
        (esaurita ? ' aria-disabled="true" class="esaurita"' : '') + '>' + ins[i].value.replace(/[&<>"]/g, '') + '</button>';
    }
    if (box.getAttribute('data-ultimo') !== html) { box.innerHTML = html; box.setAttribute('data-ultimo', html); }
    // la guida alle taglie anche nella barra, dal computer: apre il cassetto di oggi
    var guida = d.getElementById('sizeguideIcon');
    if (guida && !riga.querySelector('.bh-v-barra-guida')) {
      var bg = d.createElement('button');
      bg.type = 'button';
      bg.className = 'bh-v-barra-guida';
      bg.textContent = guida.textContent.trim();
      bg.addEventListener('click', function () { var o = d.getElementById('sizeguideIcon'); if (o) o.click(); });
      riga.appendChild(bg);
    }
  }

  // ---------- 7. ACQUISTA nella barra senza taglia: avviso e ritorno alle taglie, come il bottone della cassa ----------
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('sticky-cart-modal button[name="add"]') : null;
    if (!b || !radios || h.getAttribute('data-bh-v-pronto') === 'si') return;
    var manca = gruppi().some(function (fs) { return !fs.querySelector('input[type=radio]:checked'); });
    if (!manca) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var opener = d.getElementById('btn_form_variant');
    if (opener) opener.click();
  }, true);

  // ---------- avvio e ascolti ----------
  d.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !info || !info.contains(t) || !t.matches || !t.matches('input[type=radio]')) return;
    if (t.closest('fieldset[data-bh-colore]') && t.checked) {
      var k = chiaveDaColore(t.value);
      if (k) veste(k);
      setTimeout(function () { mosaico(); contatore(); }, 50);
    }
    pronto();
    pilloleBarra();
  });
  if (barra && 'MutationObserver' in window) {
    // global.js riscrive l'interno della barra a ogni cambio di variante: le taglie e la guida si rimettono
    new MutationObserver(function () { pilloleBarra(); }).observe(barra, { childList: true });
  }
  if (radios && 'MutationObserver' in window) {
    // le disponibilità delle taglie cambiano col colore (global.js, classe disabled): la barra le segue
    new MutationObserver(function () { pilloleBarra(); }).observe(radios, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  var tm = 0;
  // solo quando cambia la larghezza (girare il telefono): al telefono la barra del browser che compare e sparisce cambia solo l'altezza
  var largaOra = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === largaOra) return;
    largaOra = window.innerWidth;
    clearTimeout(tm); tm = setTimeout(misura, 120);
  });
  // se qualcosa sopra il titolo cambia altezza dopo il caricamento (l'avviso della lingua, per esempio), le misure si rifanno subito,
  // nello stesso fotogramma, così la cassa torna dov'era e il bottone resta nella prima schermata (solo in cima alla pagina: scorrendo
  // non si tocca niente)
  var testa = d.querySelector('.bh-v-testa'), cima = testa ? testa.getBoundingClientRect().top + window.scrollY : 0;
  if (testa && 'ResizeObserver' in window) {
    new ResizeObserver(function () {
      var c = testa.getBoundingClientRect().top + window.scrollY;
      if (Math.abs(c - cima) > 1) { cima = c; if (window.scrollY < 10) caratteri(); }
    }).observe(d.body);
  }
  // il carattere arrivato e il load rifanno solo titolo e banda (window.bhVeste.caratteri), non l'altezza della foto: la pagina non si sposta
  function caratteri() { if (window.bhVeste && window.bhVeste.caratteri) window.bhVeste.caratteri(); }
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(caratteri);
  if (d.fonts && d.fonts.addEventListener) d.fonts.addEventListener('loadingdone', caratteri);
  window.addEventListener('load', function () { rate(); caratteri(); });

  sullaFoto();
  mosaico();
  contatore();
  rate();
  pronto();
  pilloleBarra();
  caratteri();  // la foto l'ha già misurata la fine della cassa (main-product); qui solo titolo e banda
})();
